// Conteggio caratteri SMS: GSM-7 = 160 (caratteri estesi contano 2), Unicode = 70. Speculare a routers/smsfactor.py
const GSM7 = new Set("@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà");
const GSM7_EXT = new Set("^{}\\[~]|€");
export const SMS_MAX = 160;

export function smsStats(text = "") {
  const chars = Array.from(text);
  const unicode = chars.some((c) => !GSM7.has(c) && !GSM7_EXT.has(c));
  const length = unicode ? chars.length : chars.reduce((n, c) => n + (GSM7_EXT.has(c) ? 2 : 1), 0);
  const limit = unicode ? 70 : SMS_MAX;
  return { length, limit, unicode, ok: length <= limit, remaining: limit - length };
}

// Stima sul modello: sostituisce le variabili con valori realistici (le graffe non vengono inviate)
const SAMPLE = { name: "Francesca", points: "120", card: "W254875", coupon: "PROMO2026", discount: "10%", coupon_expiry: "31/12/2026" };
export function smsTemplateStats(template = "") {
  const filled = template.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, k) => SAMPLE[k] ?? "");
  return { ...smsStats(filled), preview: filled };
}
